import {memo} from 'react';

import styled, {css} from 'styled-components';

import {media} from '~/shared/theme/utils';
import {flexColumn} from '~/shared/theme/FlexLayout';
import {bodyBold} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';

import FooterLink, {FooterLinkProps} from './FooterLink';

const Root = styled.div`
  ${flexColumn}
  flex: 1;
  align-items: center;
  ${media.minLargeMobile`
    width: 168px;
    flex: none;
    align-items: flex-start;
  `}
`;

const FooterSectionTitle = styled.h3`
  width: 100%;
  ${bodyBold}
  text-align: center;
  ${media.minLargeMobile`
    text-align: initial;
  `}
`;

const FooterLinksWrapper = styled.div<{row?: boolean}>`
  width: 47%;
  margin-top: 8px;
  display: flex;
  ${({row}) => (row ? css`
    justify-content: space-between;
  ` : css`
    flex-direction: column;
  `)};
  flex-wrap: wrap;
  gap: 4px;
  ${({theme}) => media.minLargeMobile`
    width: ${theme.isLTR ? '182px' : '168px'};
  `}
`;

type FooterSectionProps = {
  title: string;
  links: FooterLinkProps[];
};

const FooterSection = ({title, links}: FooterSectionProps) => {
  const {t} = getLocalizationService();
  const isCityLinksSection = title === 'city_pages';
  return (
    <Root>
      <FooterSectionTitle>{t(title)}</FooterSectionTitle>
      <FooterLinksWrapper row={isCityLinksSection}>
        {links.map(link => {
          return <FooterLink key={`${link.text}_${link.href}_${link.cityId}`} {...link} />;
        })}
      </FooterLinksWrapper>
    </Root>
  );
};

export default memo(FooterSection);
